import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  finishLoader = false;

  constructor() {}

  ngOnInit() {
    this.hideLoader();
  }

  hideLoader() {
    setTimeout(() => {
      this.finishLoader = true;
    }, 3000);
  }
}
